import { FormControlLabel, Grid, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";

function ChannelForm({form, onChange, type="admin"}){
    const isSelf = type==="self";
    return <>
        <Grid container spacing={3}>
            <Grid item sm={12}>
                <TextField
                    autoFocus
                    fullWidth
                    required
                    size="small"
                    label="Profile (or Channel) id or name"
                    value={form.channelId || ""}
                    onChange={e => onChange({...form, channelId: e.target.value})}
                />
            </Grid>
            <Grid item sm={12}>
                <TextField
                    fullWidth
                    required
                    size="small"
                    label="Friendly name"
                    value={form.channelName || ""}
                    onChange={e => onChange({...form, channelName: e.target.value})}
                />
            </Grid>
            <Grid item sm={12}>
                <Typography variant="subtitle1">Platform</Typography>

                <RadioGroup
                    ali
                    value={form.platform || ""}
                    onChange={(e) => {
                        const platform = e.target.value;
                        onChange({
                            ...form, 
                            platform
                        })
                    }}
                >
                    <FormControlLabel value="instagram" control={<Radio />} label="Instagram" />
                    <FormControlLabel value="facebook" control={<Radio />} label="Facebook" />
                    <FormControlLabel value="twitter" control={<Radio />} label="X" />
                    <FormControlLabel value="tiktok" control={<Radio />} label="TikTok" />
                    <FormControlLabel value="telegram" control={<Radio />} label="Telegram (limited)" />
                    <FormControlLabel value="telegram" control={<Radio />} label="Telegram (limited)" />
                    {/* <FormControlLabel value="bluesky" control={<Radio />} label="Bluesky (limited)" /> */}
                </RadioGroup>
            </Grid>
        </Grid>
    </>
}
export default ChannelForm;